import React from "react";
import { Text } from "@networkraildigitalfactory/components";

const Message = (props) => {
  const { status, isLineManager, type } = props;
  const actionFor = type === "PDP" ? "development goal" : "objective";
  const getMessage = () => {
    switch (status) {
      case "pending approval":
        return isLineManager
          ? `This ${actionFor} has been sent for your approval. Please either approve or reject the ${actionFor}.`
          : `Your line manager will need to approve any edits you make to this ${actionFor}.`;
      case "review required":
        return isLineManager
          ? `This ${actionFor} has been sent back to your employee for them to review.`
          : `Your line manager has rejected this ${actionFor}. You can view their comments below and choose to re-do the ${actionFor}, or cancel it.`;
      case "approved":
        return isLineManager
          ? `You will need to approve any edits your employee makes to this ${actionFor}.`
          : `Your line manager will need to approve any edits you make to this ${actionFor}.`;
      case "employee complete":
        return isLineManager
          ? `This ${actionFor} has been marked as complete by your employee. Please either approve or decline the completion.`
          : `Your manager will need to approve the completion of this ${actionFor}.`;
      case "completed":
        return `This ${actionFor} has been completed.`;
      case "cancelled":
        return `This ${actionFor} has been cancelled.`;
      default:
        return "";
    }
  };

  const message = getMessage();

  return (
    <Text wrapper="span" type="body">
      {message}
    </Text>
  );
};

export default Message;
